(function () {
  document.querySelectorAll('[data-ftq-quiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('[data-ftq-step]');
    var progress = quiz.closest('.ftq').querySelector('[data-ftq-progress]');
    var totalQuestions = 3;
    var score = { s3: 0, s7: 0 };
    var answerHistory = []; // stores the {s3, s7} delta picked at each step
    var current = 1;

    function updateProgress(key) {
      var pct = key === 'result' ? 100 : ((key - 1) / totalQuestions) * 100;
      if (progress) progress.style.width = pct + '%';
    }

    function showStep(key) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.ftqStep === String(key));
      });
      updateProgress(key);

      // toggle back button visibility: hide it on step 1
      var backBtn = quiz.querySelector('[data-ftq-back]');
      if (backBtn) {
        backBtn.style.visibility = (key === 1) ? 'hidden' : 'visible';
      }
    }

    quiz.querySelectorAll('[data-ftq-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = {
          s3: parseInt(btn.dataset.s3 || 0, 10),
          s7: parseInt(btn.dataset.s7 || 0, 10)
        };

        // if re-answering this step (came back to it), drop the old delta first
        if (answerHistory[current - 1]) {
          score.s3 -= answerHistory[current - 1].s3;
          score.s7 -= answerHistory[current - 1].s7;
        }
        answerHistory[current - 1] = delta;
        score.s3 += delta.s3;
        score.s7 += delta.s7;

        if (current < totalQuestions) {
          current++;
          showStep(current);
        } else {
          var winner = score.s7 > score.s3 ? 's7' : 's3';
          quiz.querySelectorAll('[data-ftq-result]').forEach(function (card) {
            card.hidden = card.dataset.ftqResult !== winner;
          });
          showStep('result');
        }
      });
    });

    quiz.querySelectorAll('[data-ftq-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // if we're on the result step, step back into question 3
        if (current > totalQuestions) return;

        var wasResult = quiz.querySelector('[data-ftq-step="result"]').classList.contains('is-active');
        var targetStep = wasResult ? totalQuestions : current - 1;

        if (targetStep < 1) return;

        // undo the score contribution of the step we're leaving
        var leavingIndex = wasResult ? totalQuestions - 1 : current - 1;
        if (answerHistory[leavingIndex]) {
          score.s3 -= answerHistory[leavingIndex].s3;
          score.s7 -= answerHistory[leavingIndex].s7;
          answerHistory[leavingIndex] = null;
        }

        current = targetStep;
        showStep(current);
      });
    });

    var retake = quiz.querySelector('[data-ftq-retake]');
    if (retake) {
      retake.addEventListener('click', function () {
        score = { s3: 0, s7: 0 };
        answerHistory = [];
        current = 1;
        showStep(1);
      });
    }

    // initialize on load — this is what was missing
    showStep(1);
  });
})();